import { useAuth } from '../../auth/AuthContext';

// Thin adapter so existing broker code (which expects { email, error }) keeps
// working while auth state lives in the shared AuthContext.
export default function useBrokerEmail() {
    const { email, isLoggedIn } = useAuth();
    if (!email) {
        return {
            email: null,
            error: isLoggedIn ? 'Auth token missing email claim.' : 'Authentication token not found.',
        };
    }
    return { email, error: null };
}
